import { render, staticRenderFns } from "./FilterProducts.vue?vue&type=template&id=6e1deb42&scoped=true"
import script from "./FilterProducts.vue?vue&type=script&lang=js"
export * from "./FilterProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1deb42",
  null
  
)

export default component.exports